import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "react-modal";
import "../../Styles/Login.css";
import {
  assignPatient,
  sendOtpApi,
  UserCreateAPI,
  VerifyOtpApi,
} from "../Services/Operations/ProductAPI";
import Cookies from "js-cookie";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { setLoginData, setuserId } from "../Redux/user_information";

const Login = () => {


  // const token = JSON.parse(Cookies.get('loginData'))
 const navigate = useNavigate();



   const ref=() => {
    if(Cookies.get('loginData')){
      navigate("/")
      return
    }
    
  }
  useEffect(() => {
   ref()
  }, [])
  

  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [modalOpen, setModalOpen] = useState(false);
  const[ loading,setLoading]=useState(false)
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    dob: "",
    age: "",
    gender: "",
    co: "",
    houseBuildingApartment: "",
    streetRoadLane: "",
    landmark: "",
    areaLocalitySector: "",
    villageTownCity: "",
    postOffice: "",
    district: "",
    subDistrict: "",
    state: "",
    pincode: "",
    primaryNumber: "",
    secondaryNumber: "",
    email: "",
    roleId:"2"
  });
  const fieldTypes = {
  dob: "date",
  email: "email",
  primaryNumber: "tel",
  secondaryNumber: "tel",
  pincode: "number",
};

const [prescriptionImage,setprescriptionImage]=useState(null)
const[patientImage,setpatientImage]=useState(null)
const[aadhaarImage,setaadhaarImage]=useState(null)
const[bloodGroup,setbloodGroup]=useState("")
  const dispatch=useDispatch()

    const inputRefs = useRef([]);

  const handleSendPhone = async () => {
    if (!phone.match(/^\d{10}$/)) {
      toast.error("Please enter a valid 10-digit phone number.");
      return;
    }
    setLoading(true)
    try {
     const response= await sendOtpApi(phone);
     console.log(response);
     alert("Your otp is :"+response.otp)
      toast.success("OTP sent successfully!");
      setStep(2);
    } catch {
      toast.error("Failed to send OTP. Please try again.");
    }
    finally{
      setLoading(false)
    }
  };

  const handleVerifyOtp = async () => {
    const fullOtp = otp.join("");
    if (fullOtp.length !== 4) {
      toast.error("Please enter the complete 4-digit OTP.");
      return;
    }

    try {
      const response = await VerifyOtpApi(phone, fullOtp);
      console.log("response : ", response);
      toast.success("OTP verified successfully!");
      if (response.userExists === false) {
        console.log("..........");
        setModalOpen(true);
      } else {
        dispatch(setLoginData(response.token))
         dispatch(setuserId(response.userId))
        navigate("/");
      }
    } catch {
      toast.error("Invalid OTP. Please try again.");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if(name==="roleId"){
      return
    }
    
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmitForm = async () => {
    try {
      console.log(formData);
      
      const response = await UserCreateAPI(formData);
      console.log(response);


      
      if (response.status === 200) {
        toast.success("Details submitted successfully!");
        // setModalOpen(false);
        // setOtp(["", "", "", ""])
        // handleSendPhone()
   
        
        handleAssignPatient(response.data.id)
      }
    } catch (error) {
      toast.error("Failed to submit details. Please try again.");
    }
  };

  const handleAssignPatient=async(id)=>{
    try {
      console.log(id);
      
      const formData=new FormData()
      formData.append("patientImageFile",patientImage)
      formData.append("aadhaarImageFile",aadhaarImage)
      formData.append("prescriptionImageFile",prescriptionImage)
      formData.append("bloodGroup",bloodGroup)
      formData.append("commonUserId",JSON.stringify(id))
      const res= await assignPatient(formData)
      console.log("handleAssignPatient",res);
      if(res.status===200){
        toast.success("User assigned submit OTP")
        setModalOpen(false);
        setOtp(["", "", "", ""])
        handleSendPhone()
      }

      
    } catch (error) {
      console.log(error);
      toast.error("Failed to assign as patient")
    }
  }

  useEffect(() => {
  if (phone) {
    setFormData((prev) => ({
      ...prev,
      primaryNumber: phone,
    }));
  }
}, [phone]);


  
  const handleChange = (value, index) => {
    if (/^[0-9]$/.test(value) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to next input if digit entered
      if (value !== "" && index < 3) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  return (
    <div className="login-container">
     {!modalOpen && (
  <div className="login-box">
    <h2>Login</h2>

    {step === 1 && (
      <div className="step">
        <input
          type="tel"
          placeholder="Enter Phone Number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className="login-input"
        />
        <button onClick={handleSendPhone} className="login-button">
         {!loading? "Send OTP":"Sending.."}
        </button>
      </div>
    )}

    {step === 2 && !modalOpen && (
      <div className="step otp-step">
        <div className="otp-inputs">
          {otp.map((digit, index) => (
            <input
              key={index}
              type="text"
              maxLength="1"
              value={digit}
                ref={(el) => (inputRefs.current[index] = el)}
              onChange={(e) => handleChange(e.target.value, index)}
                 onKeyDown={(e) => handleKeyDown(e, index)}

              
              className="otp-box"
            />
          ))}
        </div>
        <button onClick={handleVerifyOtp} className="login-button">
          Verify OTP
        </button>
      </div>
    )}
  </div>
)}

        {modalOpen && (
          <div className="step user-form">
            <h3>New User - Fill Your Details</h3>
            <div className="form-grid">
              {Object.keys(formData).map((field) => (
                <input
                  key={field}
                  name={field}
                  placeholder={field.replace(/([A-Z])/g, " $1")}
                  value={formData[field]}
                  onChange={handleInputChange}
                  className="login-input"
                  
                 type={fieldTypes[field] || "text"}
                />
              ))}
              <select
                                          className="login-input"
                                          name={bloodGroup}
                                          value={bloodGroup}
                                          onChange={(e)=>setbloodGroup(e.target.value)}
                                          required
                                        >
                                          <option value="">
                                            Select Blood Group
                                          </option>
                                          <option value="A+">A+</option>
                                          <option value="A-">A-</option>
                                          <option value="B+">B+</option>
                                          <option value="B-">B-</option>
                                          <option value="O+">O+</option>
                                          <option value="O-">O-</option>
                                          <option value="AB+">AB+</option>
                                          <option value="AB-">AB-</option>
                                        </select>
                  <div style={{ width: '100%', marginBottom: '15px' }}>
  <label 
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      minHeight: '120px',
      border: '2px dashed #ccc',
      borderRadius: '8px',
      cursor: 'pointer',
      backgroundColor: '#f9f9f9',
      overflow: 'hidden'
    }}
  >
    {patientImage ? (
      /* --- This shows AFTER image is selected --- */
      <img 
        src={URL.createObjectURL(patientImage)} 
        alt="Preview" 
        style={{ width: '100%', height: '120px', objectFit: 'cover' }} 
      />
    ) : (
      /* --- This is your "Placeholder" view --- */
      <div style={{ textAlign: 'center', color: '#757575' }}>
        <p style={{ margin: 0, fontSize: '14px', fontWeight: 'bold' }}>Patient Image</p>
        <p style={{ margin: 0, fontSize: '12px' }}>Click to upload</p>
      </div>
    )}

    <input 
      type="file" 
      accept="image/*"
      style={{ display: 'none' }} 
      onChange={(e) => setpatientImage(e.target.files[0])} 
    />
  </label>
              </div>


               <div style={{ width: '100%', marginBottom: '15px' }}>
  <label 
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      minHeight: '120px',
      border: '2px dashed #ccc',
      borderRadius: '8px',
      cursor: 'pointer',
      backgroundColor: '#f9f9f9',
      overflow: 'hidden'
    }}
  >
    {aadhaarImage ? (
      /* --- This shows AFTER image is selected --- */
      <img 
        src={URL.createObjectURL(aadhaarImage)} 
        alt="Preview" 
        style={{ width: '100%', height: '120px', objectFit: 'cover' }} 
      />
    ) : (
      /* --- This is your "Placeholder" view --- */
      <div style={{ textAlign: 'center', color: '#757575' }}>
        <p style={{ margin: 0, fontSize: '14px', fontWeight: 'bold' }}>Aadhaar Image</p>
        <p style={{ margin: 0, fontSize: '12px' }}>Click to upload</p>
      </div>
    )}

    <input 
      type="file" 
      accept="image/*"
      style={{ display: 'none' }} 
      onChange={(e) => setaadhaarImage(e.target.files[0])} 
    />
  </label>
                      </div>
              <div style={{ width: '100%', marginBottom: '15px' }}>
  <label 
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      minHeight: '120px',
      border: '2px dashed #ccc',
      borderRadius: '8px',
      cursor: 'pointer',
      backgroundColor: '#f9f9f9',
      overflow: 'hidden'
    }}
  >
    {prescriptionImage ? (
      /* --- This shows AFTER image is selected --- */
      <img 
        src={URL.createObjectURL(prescriptionImage)} 
        alt="Preview" 
        style={{ width: '100%', height: '120px', objectFit: 'cover' }} 
      />
    ) : (
      /* --- This is your "Placeholder" view --- */
      <div style={{ textAlign: 'center', color: '#757575' }}>
        <p style={{ margin: 0, fontSize: '14px', fontWeight: 'bold' }}>Prescription Image</p>
        <p style={{ margin: 0, fontSize: '12px' }}>Click to upload</p>
      </div>
    )}

    <input 
      type="file" 
      accept="image/*"
      style={{ display: 'none' }} 
      onChange={(e) => setprescriptionImage(e.target.files[0])} 
    />
  </label>
            </div>
            </div>
            <button onClick={handleSubmitForm} className="login-button mt-3">
              Submit
            </button>
          </div>
        )}
    </div>
  );
};

export default Login;
